import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";

import { usePaymentTerminalColumns, usePaymentTerminalList } from "./hooks";

const PaymentTerminalList = () => {
  const columns = usePaymentTerminalColumns();
  const paymentTerminalList = usePaymentTerminalList();

  return (
    <>
      <Header>
        <ButtonLink type="primary" to={ROUTE_PATHS.PaymentTerminalCreate}>
          <FormattedMessage defaultMessage="Add new Payment Terminal" />
        </ButtonLink>
      </Header>
      <Table rowKey="id" columns={columns} {...paymentTerminalList} />
    </>
  );
};

export default PaymentTerminalList;
